import { EndpointModal } from "@/components/common/EndpointModal/EndpointModal";
import { LoadingMask } from "@/components/common/LoadingMask/LoadingMask";
import useEndpointStore from "../../stores/useEndpointStore";
import { getApiHost } from "../../stores/useEnvConfigStore";
import getDynamicConfig from "./getDynamicConfig";

const consoleTag = "[Lookup Api Endpoint]";
let resolveApiEndpoint: (value: string | PromiseLike<string>) => void;
let waitResolveApiEndpoint = new Promise<string>((resolve) => (resolveApiEndpoint = resolve));

export const checkInpasu = (value: string | null) => {
  if (!value) return false;

  return (
    ["qNtHat3lT87I33Z7", "0Cp3g12rrUqst5kh", "TxH5L4bpgIGYpFnE", "UoWAQmdvtlAvq7P0", "5yMI78vz05AgRxEM"].indexOf(
      value,
    ) > -1
  );
};

export const checkApiResponse = (body: unknown) => {
  if (!body || typeof body !== "object") return false;

  return "IsSuccess" in body;
};

const lookupApiEndpoint = {
  loading: false,
  async start() {
    if (this.loading) {
      return waitResolveApiEndpoint;
    } else {
      console.info("[Lookup Api Endpoint] start");

      this.loading = true;
      waitResolveApiEndpoint = new Promise<string>((resolve) => (resolveApiEndpoint = resolve));

      try {
        const dynamicConfig = await getDynamicConfig();

        console.info(consoleTag, "get endpoints:", dynamicConfig.apiEndpoints);

        const fetches = dynamicConfig.apiEndpoints.map((domain) =>
          fetch(`${domain}/api/system/gethealth`, {
            method: "GET",
            cache: "no-cache",
          })
            .then((x) => {
              const inpasu = x.headers.get("x-inpasu");
              return checkInpasu(inpasu) ? x.json() : Promise.reject();
            })
            .then((res) => {
              return checkApiResponse(res) ? Promise.resolve(domain) : Promise.reject();
            })
            .catch(() => Promise.reject()),
        );

        Promise.any(fetches)
          .then((fastEndpoint) => {
            console.info(consoleTag, "fast endpoint:", fastEndpoint);

            const standard = new URL(fastEndpoint).origin;

            this.loading = false;
            resolveApiEndpoint(standard);
            useEndpointStore.setState({ apiEndpoint: standard });
          })
          .catch(() => {
            console.error(consoleTag, "No endpoint can use.");

            const defaultEndpoint = getApiHost();

            resolveApiEndpoint(defaultEndpoint);

            LoadingMask.close();
            EndpointModal.open();
          })
          .finally(() => {
            this.loading = false;
          });

        return waitResolveApiEndpoint;
      } catch (e) {
        console.error(consoleTag, "error:", e);

        const defaultEndpoint = getApiHost();

        this.loading = false;
        resolveApiEndpoint(defaultEndpoint);

        return waitResolveApiEndpoint;
      }
    }
  },
};

export default lookupApiEndpoint;
